import type { FC } from 'react';
import Image from 'next/image';
import { useGlobalState } from '@/hooks';
import type { ContentItemInterface } from '@/interfaces';
import {
  ImageWrapper,
  ServicesButton,
  ServicesContainer,
  ServicesContentWrapper,
  ServiceSubTitle,
  ServiceTitle,
} from './Services.styles';

const Services: FC<ContentItemInterface> = ({
  title,
  longSubTitle,
  image,
  wrapperImage,
  buttonText,
  buttonLink,
  openInNewTab,
}) => {
  const serviceImage = wrapperImage || image;
  const { getProperImageUrl } = useGlobalState();
  return (
    <ServicesContainer>
      {serviceImage && (
        <ImageWrapper>
          <Image
            src={getProperImageUrl(serviceImage)}
            alt={serviceImage.description}
            quality={100}
            fill
            sizes='100vw'
            style={{
              objectFit: 'cover',
              objectPosition: 'center',
            }}
          />
        </ImageWrapper>
      )}
      <ServicesContentWrapper>
        <ServiceTitle>{title}</ServiceTitle>
        {longSubTitle && <ServiceSubTitle>{longSubTitle}</ServiceSubTitle>}
        {buttonText && buttonLink && (
          <ServicesButton href={buttonLink} target={openInNewTab ? '_blank' : '_self'}>
            {buttonText}
          </ServicesButton>
        )}
      </ServicesContentWrapper>
    </ServicesContainer>
  );
};

export default Services;
